export const ADD_NEW = "Add New";
export const SAVE = "Save";
export const CREATE = "Create";
export const UPDATE = "Update";
export const CANCEL = "Cancel";
export const ItemCustomerMessage = 1;
export const ItemCancelMessage = 2;

